// extracted by mini-css-extract-plugin
export default {"flex":"Flex_flex__2k3Ob","column":"Flex_column__QDEMb","inline":"Flex_inline__acYTG","start":"Flex_start__nNzNu","end":"Flex_end__-rikj","wrap":"Flex_wrap__PkymO"};